<template>
  <v-card flat class="rounded-xl overflow-hidden pa-8" v-if="ribbon_can('digikala_managment')">
         <custom-popup
    v-model="showLinkModal"
    :cons="{ title: ' اتصال دیجی‌کالا:به متنوع ' + selectedProduct?.title, icon: 'link-variant' }"
    max-width="800"
    hide-confirm
    @close="showLinkModal = false"
          @reload="(e) => (rerender = e)"
      reloadable

  >
    <link-digi-product-modal
      v-if="showLinkModal"
      :productDigi="selectedProduct"
      @saved="onProductLinked"
      @close="showLinkModal = false"
    />
  </custom-popup>

    <custom-tabs v-model="tabs" :tab-items="tabItems" grow>
      <template v-slot:staticItems>
        <v-tabs-items v-model="tabs">
          
          <!-- تب اول: لیست تنوع‌های فعال -->
          <v-tab-item>
            <div class="d-flex flex-column flex-lg-row align-center justify-space-between mb-4 gap-4">
              <v-alert type="warning" dense text class="ma-0 w-100" border="left" color="warning" colored-border elevation="2">
                در اولین استفاده از سیستم، لطفاً یک‌بار عملیات «رفرش تنوع‌ها» را انجام دهید تا اطلاعات اولیه همگام‌سازی شود.
              </v-alert>

              <v-spacer class="d-none d-lg-block"></v-spacer>

              <div class="d-flex flex-wrap justify-center justify-lg-end gap-3 w-100">
                <v-btn class="btn-upload rounded-lg flex-grow-1 flex-sm-grow-0" @click="openMassUpdateModal">
                  <v-icon left>mdi-pencil-box-multiple</v-icon>
                  قیمت گذاری گروهی ({{ selectedItems.length }})
                </v-btn>

                <v-btn class="btn-download rounded-lg flex-grow-1 flex-sm-grow-0" outlined  @click="fetch()" :loading="loading">
                  <v-icon left>mdi-refresh</v-icon>
                  بروزرسانی جدول
                </v-btn>

                <v-btn class="btn-get-code rounded-lg flex-grow-1 flex-sm-grow-0" @click="syncVariants" :loading="syncLoading">
                  <v-icon left>mdi-sync</v-icon>
                  رفرش تنوع‌ها
                </v-btn>

                <v-btn class="btn-download rounded-lg flex-grow-1 flex-sm-grow-0" @click="triggerRepricing" :loading="repriceLoading">
                  <v-icon left>mdi-calculator-variant</v-icon>
                  بررسی قیمت‌ها
                </v-btn>
              </div>
            </div>

            <vue-table
              :data="tableData"
              :headers="headers"
              :loading="syncLoading || loading"
              @change="onPagination"
              :item-class="getRowClass"
              item-key="variant_id" 
            >
              <template v-slot:filters="{ props, perPage }">
                <v-row no-gutters class="mb-4">
                  <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select v-model="props.length" :items="perPage" class="rounded-lg" dense hide-details label="تعداد در هر صفحه" outlined @change="() => onPagination(props)"/>
                  </v-col>      
                  <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select v-model="props.column" :items="columnOptions" label="مرتب‌سازی براساس" dense hide-details outlined class="rounded-lg" @change="() => onPagination(props)"/>
                  </v-col>
                  <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select v-model="props.dir" :items="dirOptions" label="جهت مرتب‌سازی" dense hide-details outlined class="rounded-lg" @change="() => onPagination(props)"/>
                  </v-col>
                    <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select v-model="props.is_linked" :items="isLinkOptions"  label="وضعیت اتصال"  dense hide-details outlined clearable class="rounded-lg" @change="() => onPagination(props)" />
                    </v-col>

                  <v-col class="pa-2" cols="12" lg="3" md="3">
                    <v-text-field v-model="props.search" append-icon="mdi-magnify" label="جستجو در عنوان..." outlined dense hide-details clearable class="rounded-lg" @keyup.enter="() => onPagination(props)" @click:clear="() => { props.search = null; onPagination(props); }"/>
                  </v-col>
                  <v-col class="pa-2" cols="12" lg="3" md="3">
                    <v-select v-model="props.flag" :items="flagOptions" label="فیلتر وضعیت" outlined prepend-inner-icon="mdi-filter-variant" dense hide-details clearable class="rounded-lg" @change="() => onPagination(props)"/>
                  </v-col>
                  <v-checkbox v-model="selectAll" color="primary" dense hide-details class="ma-0">انتخاب همه</v-checkbox>
                </v-row>
              </template>

              <template v-slot:checked="{ item }">
                <v-checkbox v-model="selectedItems" :value="item.id" @click.stop color="primary" dense hide-details class="ma-0"></v-checkbox>
              </template>

              <template v-slot:index="{item}">
                {{ persian(item.index + 1 + (tableData.current_page - 1) * tableData.per_page) }}
              </template>

              <template v-slot:image_src="{ item }">
                <div class="d-flex flex-column align-center pa-2">
                  <v-img :src="item.image_src" max-width="115" max-height="115" contain />
                </div>
              </template>

              <template v-slot:kala="{ item }">
                    <div class="d-flex flex-column align-start text-right py-2">
                        <div class="d-flex align-center gap-2 mb-1 flex-wrap">
                        <!-- چیپ وضعیت اتصال با رنگ مجزا -->
                        <v-chip
                            x-small
                            label
                            :color="item.is_linked ? 'success' : 'error'"
                            text-color="white"
                            class="font-weight-bold px-2"
                        >
                            <v-icon x-small left>{{ item.is_linked ? 'mdi-link-variant' : 'mdi-link-variant-off' }}</v-icon>
                            {{ item.is_linked ? 'متصل' : 'عدم اتصال' }}
                        </v-chip>

                        <span class="product-title font-weight-bold">
                            <template v-if="item.title && item.title.includes(':')">
                            <span>{{ item.title.split(':')[0] }} :</span>
                            <span class="primary--text mr-1">{{ item.title.split(':').slice(1).join(':') }}</span>
                            </template>
                            <template v-else>
                            {{ item.title }}
                            </template>
                        </span>
                        </div>                 
                        <div class="d-flex align-center gap-2 grey--text text--darken-1 text-caption">
                        <a :href="`https://www.digikala.com/product/dkp-${item.product_id}`" target="_blank" class="dkp-link">DKP-{{ item.product_id }}</a>
                        <span class="mx-1">|</span>
                        <span>{{ item.product_id }}</span>
                        <span class="mx-1">|</span>
                        <span class="variant-code">DKPC-{{ item.variant_id }}</span>
                        </div>
                    </div>
              </template>

              <template v-slot:variant_id="{item}">
                <v-chip class="px-2 py-3 rounded-lg" color="transparent">
                  <span class="text-body-2 font-weight-bold">{{ persian(item.variant_id) }}</span>
                  <v-btn icon small @click.stop="copyID(item.variant_id)" class="ms-2" color="#B5C5FD">
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </v-chip>
              </template>

              <template v-slot:updated_at="{ item }">
                <v-icon small class="ml-1">mdi-clock-outline</v-icon>
                {{ item.updated_at==null?'به روزرسانی نشده' : jalalian(item.updated_at,"datetime") }}
              </template>

              <template v-slot:smart_updated_at="{ item }">
                <v-icon small class="ml-1">mdi-clock-outline</v-icon>
                {{ item.smart_updated_at==null?'قیمت گذاری نشده': jalalian(item.smart_updated_at,"datetime") }}
              </template>                          

              <template v-slot:flag="{ item }">
                <v-chip :color="getFlagColor(item.flag)" text-color="white" small class="pa-2">
                  {{ getFlagText(item.flag) }}
                </v-chip>
              </template>

              <template v-slot:action="{ item }">
                <div @click.stop.prevent @mousedown.stop.prevent>
                  <v-btn
                    :icon="$vuetify.breakpoint.mdAndUp"
                    :class="[
                      'btn-show rounded-pill',
                      $vuetify.breakpoint.mdAndUp ? 'pa-0' : 'px-3 py-1 text-caption'
                    ]"
                    title="اتصال به دیجی‌کالا"
                    @click="linkProduct(item)"
                  >
                    <v-icon small :left="$vuetify.breakpoint.smAndDown">
                      mdi-link-variant-plus
                    </v-icon>                    
                    <span class="d-md-none">اتصال به دیجی‌کالا</span>
                  </v-btn>

                  <action-buttons :data="item" :meta="getMetaButton(item)"/>
                </div>
              </template>
            </vue-table>
          </v-tab-item>

          <!-- تب دوم: لیست تنوع‌های غیرفعال -->
          <v-tab-item>
            <show-set-price_deactive :store_id="store_id"/>
          </v-tab-item>
           <v-tab-item>
            <archive-variants 
              @link="linkProduct" 
              @edit="editAction" 
              @multi_pricing="openMultiPricing" :store_id="store_id"
            />
          </v-tab-item>
                    <!-- تب جهارم: لیست سفارشات -->
          <v-tab-item>
            <orders :store_id="store_id"/>
          </v-tab-item>

        </v-tabs-items>
      </template>
    </custom-tabs>

    <!-- مدال ویرایش تکی -->
    <custom-popup v-model="showDialog" :cons="{ title: 'افزودن/ویرایش قیمت هوشمند' }" max-width="800" :reloadable="false" :persistent="true" @close="resetForm">
      <v-card class="pa-4" flat>
      <h3 class="d-flex justify-center primary--text">{{ selected_product_title }}</h3>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-divider class="mb-4"></v-divider>
          <div class="text-subtitle-2 font-weight-bold mb-3">روش ارسال و هزینه‌های دیجی‌کالا</div>
          <v-card class="elevation-3" color="#CCC8DB89" colored-border>
            <v-row class="mb-4 bg-grey-lighten-4 pa-2 rounded align-center">
              <v-col cols="12" md="12" class="d-flex flex-column justify-center align-start" style="border-left: 1px solid #e0e0e0;">
                <div class="text-caption text-grey mb-1">روش ارسال</div>
                <div class="d-flex align-center">
                  <v-checkbox v-model="formData.is_fbd_active" label="دیجی‌کالا" dense hide-details class="mt-0 mr-2"></v-checkbox>
                  <v-checkbox v-model="formData.is_fbs_active" label="فروشنده" dense hide-details class="mt-0 mr-2"></v-checkbox>
                  <v-checkbox v-model="formData.is_three_hour_delivery_active" label="۳ ساعته" dense hide-details class="mt-0"></v-checkbox>
                </div>
              </v-col>
              <v-divider class="mb-4"></v-divider>
              <v-col cols="12" md="3" style="border-left: 1px solid #e0e0e0;">
                <v-select v-model="formData.lead_time" :items="leadTimeOptions" label="مهلت تحویل به انبار دیجی‌کالا" dense outlined hide-details :disabled="!formData.is_fbd_active"></v-select>
              </v-col>
              <v-col cols="12" md="3" style="border-left: 1px solid #e0e0e0;">
                <v-select v-model="formData.delivery_time" :items="deliveryTimeOptions" label="مهلت تحویل به خریدار" dense outlined hide-details :disabled="!formData.is_fbs_active && !formData.is_fbd_active"></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select v-model="formData.seller_lead_time" :items="sellerLeadTimeOptions" label="بازه زمانی از ثبت سفارش تا تحویل" dense outlined hide-details :disabled="(!formData.is_fbs_active && !formData.is_three_hour_delivery_active) || formData.delivery_time!==0"></v-select>
              </v-col>
            </v-row>
          </v-card>
          <v-divider class="mb-4"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <price-input v-model="formData.min_price" label="حداقل قیمت نهایی" dense class="bg-grey-lighten-3" :rules="[ (v) => !!v || 'وارد کردن حداقل قیمت الزامی است', (v) => Number(String(v).replace(/,/g, '')) >= 0 || 'قیمت نمی‌تواند منفی باشد']" :min="0"/>
            </v-col>
            <v-col cols="12" md="6">
              <price-input v-model="formData.max_price" label="حداکثر قیمت نهایی" dense class="bg-grey-lighten-3" :rules="[ (v) => !!v || 'وارد کردن حداکثر قیمت الزامی است', (v) => Number(String(v).replace(/,/g, '')) >= 0 || 'قیمت نمی‌تواند منفی باشد', (v) => Number(String(v).replace(/,/g, '')) > Number(String(formData.min_price || 0).replace(/,/g, '')) || 'حداکثر قیمت باید حتماً بزرگتر از حداقل قیمت باشد']" @input="calculateDefaultStep" :min="formData.min_price" />
            </v-col>
            <v-col cols="12" md="6">
              <price-input v-model.number="formData.price_step" label="کسر قیمت" :rules="[(v) => !!v || 'وارد کردن کسر قیمت الزامی است', (v) => Number(String(v).replace(/,/g, '')) >= 2000 || 'کسر قیمت نمی‌تواند کمتر از 2000 باشد']" min="2000" dense/>
            </v-col>
            <v-col cols="12" md="6" class="d-flex align-center gap-4">
              <v-switch v-model="formData.is_enabled" label="وضعیت فعالیت" color="primary" hide-details></v-switch>
              <v-switch v-model="formData.has_discount" :true-value="1" :false-value="0" :label="formData.has_discount===1?'بر حسب تخفیف':'بر حسب کسر قیمت'" color="primary" hide-details></v-switch>
            </v-col>
          </v-row>
          <div class="d-flex flex-row justify-space-between mt-6">
            <v-btn :loading="saving" class="btn-get-code rounded-lg px-6" @click="saveData" :disabled="!valid || !validComputed">
              <v-icon left>mdi-check</v-icon> ثبت
            </v-btn>  
            <v-btn :loading="saving" class="btn-delete rounded-lg px-6" @click="showDialog = false">
              <v-icon left>mdi-close</v-icon> لغو
            </v-btn>        
          </div>
        </v-form>
      </v-card>
    </custom-popup>

    <!-- مدال ویرایش گروهی -->
    <custom-popup v-model="showMassUpdateModal" :cons="{ title: 'قیمت گذاری گروهی' }" max-width="800" class="mass-update-popup" hide-confirm>
      <v-card class="rounded-0" outlined flat>
        <v-form ref="massUpdateForm" v-model="valid" lazy-validation>
          <v-row class="pa-4">
            <v-col cols="12">
              <span class="text-subtitle-1 font-weight-bold">موارد انتخاب شده:</span>
              <v-chip-group column>
                <v-chip v-for="(item, index) in selectedFullObjects" :key="item.variant_id" close color="primary" outlined @click:close="removeSelectedItem(item.id)">
                  تنوع: {{ item.variant_id }} | کالا: {{ item.product_id }}
                </v-chip>
              </v-chip-group>
              <div v-if="selectedItems.length === 0" class="error--text text-caption mt-2">هیچ تنوعی انتخاب نشده است.</div>
            </v-col>
            <v-col cols="12">
              <div class="text-subtitle-2 font-weight-bold mb-3 mt-4">روش ارسال و هزینه‌های دیجی‌کالا</div>
              <v-card class="elevation-3" color="#CCC8DB89" colored-border>
                <v-row class="mb-4 bg-grey-lighten-4 pa-2 rounded align-center">
                  <v-col cols="12" md="12" class="d-flex flex-column justify-center align-start" style="border-left: 1px solid #e0e0e0;">
                    <div class="text-caption text-grey mb-1">روش ارسال</div>
                    <div class="d-flex align-center">
                      <v-checkbox v-model="formData.is_fbd_active" label="دیجی‌کالا" dense hide-details class="mt-0 mr-2"></v-checkbox>
                      <v-checkbox v-model="formData.is_fbs_active" label="فروشنده" dense hide-details class="mt-0 mr-2"></v-checkbox>
                      <v-checkbox v-model="formData.is_three_hour_delivery_active" label="۳ ساعته" dense hide-details class="mt-0"></v-checkbox>
                    </div>
                  </v-col>
                  <v-divider class="mb-4"></v-divider>
                  <v-col cols="12" md="3" style="border-left: 1px solid #e0e0e0;">
                    <v-select v-model="formData.lead_time" :items="leadTimeOptions" label="مهلت تحویل به انبار دیجی‌کالا" dense outlined hide-details :disabled="!formData.is_fbd_active"></v-select>
                  </v-col>
                  <v-col cols="12" md="3" style="border-left: 1px solid #e0e0e0;">
                    <v-select v-model="formData.delivery_time" :items="deliveryTimeOptions" label="مهلت تحویل به خریدار" dense outlined hide-details :disabled="!formData.is_fbs_active && !formData.is_fbd_active"></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select v-model="formData.seller_lead_time" :items="sellerLeadTimeOptions" label="بازه زمانی از ثبت سفارش تا تحویل" dense outlined hide-details :disabled="(!formData.is_fbs_active && !formData.is_three_hour_delivery_active) || formData.delivery_time!==0"></v-select>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-divider class="my-4 w-100"></v-divider>
            <v-col cols="12" md="6">
              <price-input v-model="formData.min_price" label="حداقل قیمت" :rules="[ (v) => !!v || 'وارد کردن حداقل قیمت الزامی است', (v) => Number(String(v).replace(/,/g, '')) >= 0 || 'قیمت نمی‌تواند منفی باشد']" dense :min="0"/>
            </v-col>
            <v-col cols="12" md="6">
              <price-input v-model="formData.max_price" label="حداکثر قیمت" :rules="[ (v) => !!v || 'وارد کردن حداکثر قیمت الزامی است', (v) => Number(String(v).replace(/,/g, '')) >= 0 || 'قیمت نمی‌تواند منفی باشد', (v) => Number(String(v).replace(/,/g, '')) > Number(String(formData.min_price || 0).replace(/,/g, '')) || 'حداکثر قیمت باید حتماً بزرگتر از حداقل قیمت باشد']" dense :min="formData.min_price" @input="calculateDefaultStep" />
            </v-col>
            <v-col cols="12" md="6">
              <price-input v-model.number="formData.price_step" label="کسر قیمت" :rules="[ (v) => !!v || 'وارد کردن کسر قیمت الزامی است', (v) => Number(String(v).replace(/,/g, '')) >= 2000 || 'کسر قیمت نمی‌تواند کمتر از 2000 باشد']" min="2000" dense />
            </v-col>
            <v-col cols="12" md="6">
              <v-switch v-model="formData.is_enabled" label="وضعیت فعالیت" color="primary"></v-switch>
            </v-col>
            <v-col cols="12" md="6">
              <v-switch v-model="formData.has_discount" :true-value="1" :false-value="0" :label="formData.has_discount===1 ? 'بر حسب تخفیف':'بر حسب کسر قیمت'" color="primary"></v-switch>
            </v-col>
          </v-row>
          <v-card-actions class="pa-4 d-flex justify-space-between">
            <v-btn class="btn-delete rounded-lg" @click="showMassUpdateModal = false">
              <v-icon left small>mdi-close</v-icon> انصراف
            </v-btn>
            <v-btn class="btn-get-code rounded-lg" :loading="saving" :disabled="selectedItems.length === 0 || !validComputed" @click="saveMassUpdate">
              <v-icon left small>mdi-content-save-all</v-icon> اعمال تغییرات روی {{ selectedItems.length }} مورد
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </custom-popup>

    <!-- مدال قیمت‌گذاری چند حالته -->
    <custom-popup v-model="showMultiPricingDialog" :cons="{ title: 'قیمت‌گذاری چند حالته' }" max-width="1000" :reloadable="false" :persistent="true">
      <multi-pricing-form v-if="showMultiPricingDialog" :product-data="selectedMultiPricingData" @close="showMultiPricingDialog = false" @saved="onMultiPricingSaved" />
    </custom-popup>

  </v-card>
</template>

<script>
import ActionButtons from "@/view/components/adapters/qrList/ordersListButton.vue";
import ShowSetPrice_deactive from "./ShowSetPrice_deactive.vue";
import PriceInput from "../../../core/plugins/TitleRibbon/pages/pickers/priceInput.vue";
import MultiPricingForm from "./MultiPricingForm.vue";
import LinkDigiProductModal from "./LinkDigiProductModal.vue";
import ArchiveVariants from "./ArchiveVariants.vue";
import Orders from "./Orders.vue";
import { integer } from "vuelidate/lib/validators";


export default {
  name: "productVarient",
  components: { 
    ActionButtons,
    ShowSetPrice_deactive,
    PriceInput,
    MultiPricingForm,
    LinkDigiProductModal,
    ArchiveVariants,
    Orders
  },
  props:{
    store_id:{
      type:Number,
      default:null
    }
  },
  data: () => ({
    rerender: true,
    selectedProduct: null,
    showLinkModal: false,
    isLinkOptions: [
  { text: 'همه موارد', value: null },
  { text: 'متصل شده', value: 1 },
  { text: 'متصل نشده', value: 0 },
],
    idselected:0,
    showMultiPricingDialog: false,
    selectedMultiPricingData: null,
    selected_product_title:"",
    leadTimeOptions: [
      { text: '۱ روز', value: 1 },
      { text: '۲ روز', value: 2 },
      { text: '۳ روز', value: 3 },
    ],
    deliveryTimeOptions: [
      { text: 'همان‌روز', value: 0 },
      { text: '۱ روز', value: 1 },
      { text: '۲ روز', value: 2 },
    ],
    sellerLeadTimeOptions: [
      { text: 'تا ۲ ساعت', value: 2 },
      { text: 'تا ۳ ساعت', value: 3 },
      { text: 'تا ۴ ساعت', value: 4 },
      { text: 'تا ۵ ساعت', value: 5 },
    ],
    selectedItems:[],
    showMassUpdateModal:false,
    SmartRow:{},
    loading: false,
    saving: false,
    showDialog: false,
    isEditing: false,
    valid: false,
    formData: {
      id: null,
      variant_id: null,
      product_id: null,
      base_min_price: 0, 
      base_max_price: 0, 
      min_price: 0,      
      max_price: 0,      
      price_step: 20000,
      is_enabled: true,
      has_discount: 0,
      calc_shipping: true,
      is_fbd_active: true,
      is_fbs_active: true,
      is_three_hour_delivery_active: true,
      lead_time: 1,
      delivery_time: 0,
      seller_lead_time: 3,
    },
    defaultForm: {
      id: null,
      variant_id: null,
      product_id: null,
      min_price: 0,
      max_price: 0,
      price_step: 20000,
      is_enabled: true,
      has_discount: 0,
      calc_shipping: true,
      is_fbd_active: true,
      is_fbs_active: true,
      is_three_hour_delivery_active: true,
      lead_time: 1,
      delivery_time: 0,
      seller_lead_time: 3,
    },
    tabs: 0,
    tableProps: {
      page: 1,
      length: 10,
      search: null,
      flag: null,
      dir: 'desc',
      column: 'updated_at',
      status:1,
     is_linked: null,
     is_archived:false,
     store_id:null
    },
    flagOptions: [
      { text: 'همه موارد', value: null },
      { text: 'سبز (بدون رقیب/سقف)', value: 'green' },
      { text: 'زرد (رقیب بالاتر/سقف)', value: 'yellow' },
      { text: 'قرمز (رقابت در بازه مجاز)', value: 'red' },
      { text: 'نارنجی (رقیب ارزان‌تر از کف)', value: 'orange' }
    ],
    columnOptions: [
      { text: "تاریخ بروزرسانی", value: "updated_at" },
      { text: "شناسه تنوع", value: "variant_id" },
      { text: "تاریخ بروزرسانی قیمت", value: "smart_updated_at" },
    ],
    dirOptions: [
      { text: "نزولی", value: "desc" },
      { text: "صعودی", value: "asc" }
    ],
    tableData: {
      data: [],
      total: 0,
      current_page: 1,
      per_page: 10
    },
    syncLoading: false,
    repriceLoading: false,
    headers: [
      { value: 'checked',text:'انتخاب',sortable:false,align:'center'},
      { value: 'index', text: 'ردیف', sortable: false, align: 'center' },
      { value: 'variant_id', text: 'شناسه تنوع', sortable: false, align: 'center' },
      { value: 'image_src', text: 'تصویر محصول', sortable: false, align: 'center' },
      { value: 'kala', text: 'عنوان و کد محصول', sortable: false, align: 'center' },
      { value: 'flag', text: 'وضعیت', sortable: false, align: 'center' },
      { value: 'updated_at', text: 'آخرین به‌روزرسانی', sortable: false, align: 'center' },
      { value: 'smart_updated_at', text: 'آخرین به روزرسانی قیمت',sortable: false, align: 'center'},
      { text: "قیمت‌گذاری", value: "action", sortable: false, align: "center"}
    ],
  }),
  mounted() {
    this.fetch();
  },
  computed:{
    selectAll: {
      get() { return this.tableData.data.length > 0 && this.selectedItems.length === this.tableData.data.length; },
      set(val) { this.selectedItems = val ? this.tableData.data.map(item => item.id) : []; }
    },
    selectedFullObjects() { return this.tableData.data.filter(item => this.selectedItems.includes(item.id)); },
    massProductIds() { return this.selectedFullObjects.map(item => item.product_id); },
    massVariantIds() { return this.selectedFullObjects.map(item => item.variant_id); },
 tabItems() {
      const tabs = [];
      if (this.ribbon_can('digikala_managment')) {
        tabs.push({ text: "لیست تنوع‌های فعال", value: 0, icon: 'format-list-bulleted' });
        tabs.push({ text: "لیست تنوع‌های غیرفعال", value: 1, icon: 'format-list-bulleted' });
        tabs.push({ text: "بایگانی تنوع", value: 2, icon: 'archive' });
        tabs.push({ text: "سفارشات", value: 3, icon: 'order-alphabetical-ascending' });

      }
      return tabs;
    },    validComputed(){ return !!this.formData.max_price && !!this.formData.min_price; },

  },
  methods: {
    openDigiManag(item) {
        const variantId = item.variant_id;
        const url = `https://seller.digikala.com/pwa/variant-management?filterSearchIn=search_term&filterSearchQuery=${variantId}&page=1`;
        
        window.open(url, '_blank');
      },
    openDigiShow(item) {
        const dkp = item.product_id;
        const url = `https://www.digikala.com/product/dkp-${dkp}/`;
        
        window.open(url, '_blank');
      },
  getMetaButton(item) {
    const buttons = [
         {
          name: "translateShowDigi",
          label: "نمایش در دیجی‌کالا",
          icon: "open-in-new", // تغییر از eye به open-in-new
          class: "btn-show rounded-pill",
          action: (row) => this.openDigiShow(row),
        },
        {
          name: "translateManagementDigi",
          label: "مدیریت در دیجی‌کالا",
          icon: "store-edit-outline",
          class: "btn-buy rounded-pill",
          action: (row) => this.openDigiManag(row),
        },

      {
        name: "edit",
        label: "قیمت‌گذاری هوشمند",
        icon: "cash-sync",
        class: "btn-download rounded-pill",
        action: this.actionsTe,
      },
      {
        name: "multi_pricing",
        label: "قیمت‌گذاری چند حالته",
        icon: "layers-triple-outline",
        class: "btn-get-code rounded-pill ml-2",
        action: this.actionsTe,
      },
      {
        name: "delete",
        label: "بایگانی",
        icon: "archive-outline",
        class: "btn-delete rounded-pill",
        action: (row) => this.deleteListing(row),
      },
    ];

    if (item && item.is_linked) {
      buttons.push({
        name: "unlink",
        label: "قطع اتصال",
        icon: "link-off",
        class: "btn-edit rounded-pill",
        action: (row) => this.unlinkListing(row),
      });
    }

    return { buttons };
  },
    preparePayload(data) {
      const payload = { ...data };
      if (!payload.is_fbd_active) payload.lead_time = null;
      if (!payload.is_fbs_active) {
        payload.delivery_time = null;
        payload.seller_lead_time = null;
      }
      if (!payload.is_fbs_active && !payload.is_three_hour_delivery_active) payload.seller_lead_time = null;
      return payload;
    },
    calculateDefaultStep(value) {
      const val = Number(String(value).replace(/,/g, ''));
      if (!val) return;
      let step = 20000;
      if (val > 2000000) {
        step = 200000; 
        if(val > 2500000) step = 250000;
        if(val > 3000000) step = 300000;
        if(val > 3500000) step = 350000;
        if(val > 4000000) step = 400000;
        if(val > 4500000) step = 450000;
        if(val > 5000000) step = 500000;
      } else if (val > 1500000) step = 150000;
      else if (val > 1000000) step = 100000;
      else if (val > 800000) step = 80000;
      else if (val > 700000) step = 70000;
      else if (val > 500000) step = 50000;
      else if (val > 200000) step = 40000;
      else if (val > 100000) step = 30000;
      this.formData.price_step = step;
    },
    removeSelectedItem(id) {
      this.selectedItems = this.selectedItems.filter(itemId => itemId !== id);
      if (this.selectedItems.length === 0) this.showMassUpdateModal = false;
    },
    openMassUpdateModal() {
      if (this.selectedItems.length === 0) return;
      const getCommonValue = (key) => {
        const firstVal = this.selectedFullObjects[0][key];
        const isCommon = this.selectedFullObjects.every(item => item[key] === firstVal);
        return isCommon ? firstVal : null;
      };
      this.formData = {
        min_price: getCommonValue('min_price') ?? 0,
        max_price: getCommonValue('max_price') ?? 1,
        price_step: getCommonValue('price_step') ?? 20000,
        is_enabled: getCommonValue('is_enabled') ?? true,
        has_discount: getCommonValue('has_discount') ?? 0,
        is_fbd_active: getCommonValue('is_fbd_active') ?? true,
        is_fbs_active: getCommonValue('is_fbs_active') ?? true,
        is_three_hour_delivery_active: getCommonValue('is_three_hour_delivery_active') ?? true,
        lead_time: getCommonValue('lead_time') ?? 1,
        delivery_time: getCommonValue('delivery_time') ?? 0,
        seller_lead_time: getCommonValue('seller_lead_time') ?? 3,
      };
      this.showMassUpdateModal = true;
    },
    openAddDialog() {
      this.isEditing = false;
      this.formData = { ...this.defaultForm };
      this.showDialog = true;
    }, 
    resetForm() {
      this.formData = { ...this.defaultForm };
      this.isEditing = false;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    saveMassUpdate() {
      this.saving = true;
      const sanitizedData = this.preparePayload(this.formData);
      const payload = {
        product_ids: this.massProductIds,
        variant_ids: this.massVariantIds,
        min_price: sanitizedData.min_price,
        max_price: sanitizedData.max_price,
        price_step: sanitizedData.price_step,
        is_enabled: sanitizedData.is_enabled,
        has_discount: sanitizedData.has_discount,
        is_fbd_active: sanitizedData.is_fbd_active,
        is_fbs_active: sanitizedData.is_fbs_active,
        is_three_hour_delivery_active: sanitizedData.is_three_hour_delivery_active,
        lead_time: sanitizedData.lead_time,
        delivery_time: sanitizedData.delivery_time,
        seller_lead_time: sanitizedData.seller_lead_time,
      };
      this.$api.post("/v1/digikala/multi-pricing/bulk-upsert", payload).then(() => {
        this.$toast.success("قیمت‌گذاری گروهی با موفقیت ثبت شد");
        this.showMassUpdateModal = false;
        this.selectedItems = [];
        this.fetch();
      }).catch(() => {
        this.$toast.error("خطا در ذخیره اطلاعات گروهی");
      }).finally(() => {
        this.saving = false;
      });
    },
    saveData() {
      this.saving = true;
      const method = this.isEditing ? "put" : "post";
      const url = this.isEditing ? `/v1/digikala/multi-pricing/${this.idselected}` : "/v1/digikala/multi-pricing/store";
      const finalPayload = this.preparePayload(this.formData);
      this.$api[method](url, finalPayload).then(() => {
        this.$toast.success(this.isEditing ? "با موفقیت ویرایش شد" : "با موفقیت ذخیره شد");
        this.showDialog = false;
        this.fetch();
      }).catch(() => {
        this.$toast.error("خطا در ذخیره اطلاعات");
      }).finally(() => {
        this.saving = false;
      });
    },
    actionsTe(data, type) {
      if (type === "edit") this.editAction(data);
      else if (type === "multi_pricing") this.openMultiPricing(data); 
      else if(type==='link'){
        this.linkProduct(data);
      }
    },
    linkProduct(item) {
      this.selectedProduct = item;
      this.showLinkModal = true;
    },
    onProductLinked() {
      this.showLinkModal = false;
      this.fetch();
    },

    async openMultiPricing(data) {
      this.selectedMultiPricingData = data;
      this.showMultiPricingDialog = true;
    },
    onMultiPricingSaved() {
      this.showMultiPricingDialog = false;
      this.fetch(); 
    },
    async editAction(data) {
      await this.getSmartRow(data);
      this.showDialog = true;
    },
    copyID(textToCopy) {
      const text = String(textToCopy); 
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$toast.success("با موفقیت کپی شد");
        }).catch((err) => {
          console.error("Clipboard error:", err);
          this.$toast.error("خطا در کپی");
        });
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.$toast.success("با موفقیت کپی شد");
      }
    },

    getRowClass(item) {
    let classes = [];    
    if (item.flag) {
        const flagMap = { green: 'row-bg-green', yellow: 'row-bg-yellow', red: 'row-bg-red', orange: 'row-bg-orange' };
        if (flagMap[item.flag]) classes.push(flagMap[item.flag]);
    }    
    classes.push(item.is_linked ? 'row-linked' : 'row-unlinked');
    return classes.join(' ');
    },
    async getSmartRow(data){
      try {
        this.idselected = data.id;
        const res = await this.$api.get(`v1/digikala/multi-pricing/find/${data.id}`);
        this.SmartRow = res?.data?.data; 
        if(this.SmartRow == null || this.SmartRow == undefined) {
          this.isEditing = false;
          this.selected_product_title= data.title;
          this.formData={...this.defaultForm, variant_id:data.variant_id, product_id:data.product_id}
        }else{
          this.isEditing = true;
          this.selected_product_title= this.SmartRow.product_title;
          this.formData = {  
            ...this.defaultForm, ...this.SmartRow,
            is_fbd_active: this.SmartRow.is_fbd_active ?? true,
            is_fbs_active: this.SmartRow.is_fbs_active ?? true,
            is_three_hour_delivery_active: this.SmartRow.is_three_hour_delivery_active ?? true,
            lead_time: this.SmartRow.lead_time ?? 1,
            delivery_time: this.SmartRow.delivery_time ?? 0,
            seller_lead_time: this.SmartRow.seller_lead_time ?? 3,
          };
        }
      } catch (error) {
        this.$toast.error("خطا در دریافت قیمت گذاری هوشمند");
      }
    },
    async fetch() {
        this.loading = true;
        this.tableProps.store_id = this.store_id||null;
        try {
            const res = await this.$api.get('/v1/digikala/variant-list', { params: this.tableProps });
            this.tableData = res.data.data || res.data; 
        } catch (error) {
            this.$toast.error("خطا در دریافت لیست تنوع‌ها");
        } finally {
            this.loading = false;
        }
        },
        onPagination(e) {
        if (e && typeof e === 'object' && !Array.isArray(e)) {
            if (
            ('search' in e && e.search !== this.tableProps.search) || 
            ('flag' in e && e.flag !== this.tableProps.flag) ||
            ('is_linked' in e && e.is_linked !== this.tableProps.is_linked)
            ) {
            e.page = 1;
            }
            this.tableProps = { ...this.tableProps, ...e };
        }
        this.fetch();
        },
    async syncVariants() {
      this.syncLoading = true;
      try {
        await this.$api.post(`/v1/digikala/sync-variants/${this.store_id}`);
        this.$toast.success("درخواست همگام‌سازی با موفقیت در صف قرار گرفت");
        this.fetch();
      } catch (error) {
        this.$toast.error("خطا در همگام‌سازی تنوع‌ها");
      } finally {
        this.syncLoading = false;
      }
    },
    async triggerRepricing() {
      this.repriceLoading = true;
      try {
        await this.$api.post('/v1/digikala/repricing');
        this.$toast.success("درخواست بررسی قیمت‌ها در صف قرار گرفت");
      } catch (error) {
        this.$toast.error("خطا در اجرای عملیات قیمت‌گذاری");
      } finally {
        this.repriceLoading = false;
      }
    },
    getFlagText(flag) {
      const map = { green: "رقیب ندارد (قیمت سقف)", yellow: "قیمت رقیب بالا (قیمت سقف)", red: "کسری قیمت (رقابت)", orange: "رقیب ارزان‌تر از کف (قیمت کف)" };
      return map[flag] || flag || "بررسی نشده";
    },
    getFlagColor(flag) {
      const map = { green: "success", yellow: "warning", red: "error", orange: "orange" };
      return map[flag] || "grey";
    },
    async unlinkListing(item) {
      const confirm = await this.$modal.yesNo(
        `آیا از قطع اتصال این محصول از ${item.marketplace} اطمینان دارید؟`
      );
      if (!confirm) return;

      this.loading = true;
      try {
         
         await this.$api.post(`v1/marketplace-listings/unlink-by-variant`,{  "marketplace": "digikala", 
          "external_variant_id": item.variant_id});
        this.$toast.success("اتصال قطع شد.");
        this.fetchListings();
      } catch (e) {
        this.$toast.error("خطا در قطع اتصال");
      } finally {
        this.loading = false;
      }
    },

    async deleteListing(item) {
      const confirm = await this.$modal.yesNo(`آیا از بایگانی این محصول اطمینان دارید؟`);
      if (!confirm) return;

      this.loading = true;
      try {
        await this.$api.post(`/v1/digikala/${item.id}/archive`);
        this.$toast.success(" با موفقیت بایگانی شد.");
            this.fetch();

      } catch (e) {
        this.$toast.error("خطا در بایگانی لیستینگ");
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style scoped>
.gap-4 { gap: 16px; }
::v-deep .row-bg-green { background-color: #e8f5e9 !important; }
::v-deep .row-bg-yellow { background-color: #fffde7 !important; }
::v-deep .row-bg-red { background-color: #ffebee !important; }
::v-deep .row-bg-orange { background-color: #fff3e0 !important; }
::v-deep .row-bg-green:hover { background-color: #c8e6c9 !important; }
::v-deep .row-bg-yellow:hover { background-color: #fff9c4 !important; }
::v-deep .row-bg-red:hover { background-color: #ffcdd2 !important; }
::v-deep .row-bg-orange:hover { background-color: #ffe0b2 !important; }
.gap-2 { gap: 8px; }
.product-title { font-size: 0.9rem; color: #424242; line-height: 1.6; }
.dkp-link { text-decoration: none; color: #1976d2; font-weight: 500; border-bottom: 1px dashed #1976d2; }
.variant-code { background: #f0f0f0; padding: 2px 6px; border-radius: 4px; font-family: monospace; }
::v-deep .row-linked { border-right: 4px solid #4caf50 !important;}
::v-deep .row-unlinked { border-right: 4px solid #f44336 !important; opacity: 0.88; }

</style>
